import styles from './index.less';
// import defaultInfoUrl1 from '@/assets/home/default_info1.png';
import defaultInfoUrl2 from '@/assets/home/default_info2.png';
import { formattedTime } from '@/utils/format';
import { Arrow, EyeO } from '@react-vant/icons';
import { FC } from 'react';
import NoData from '@/components/NoData';
import { history } from '@umijs/max';
import { Empty, Image } from 'react-vant';

interface InformationProps {
  click: (value: any) => void;
  title: string;
  list: Array<any>;
  type: string;
}

const Information: FC<InformationProps> = (props) => {
  const { click, title, list, type } = props;
  // console.log(list);
  const toMore = () => {
    if (type === '1') {
      history.push('/wechatNews');
    }

    if (type === '2') {
      history.push('/wechatActivity');
    }
  };
  return (
    <div className={styles.information}>
      <div className={styles.title}>
        <div>{title}</div>
        <div onClick={toMore} className={styles.more}>
          更多
          <Arrow />
        </div>
      </div>

      {list?.length !== 0 ? (
        <>
          {list.map((item) => (
            <div
              onClick={() => click(item)}
              className={styles.content}
              key={item.sequenceNbr}
            >
              <Image
                fit="cover"
                width="132"
                height="80"
                src={item.image || defaultInfoUrl2}
                alt={item.title}
              />
              <div className={styles.box}>
                <p className={styles.subTitle}>{item.title}</p>
                <div className={styles['viewBox']}>
                  <div>
                    {item.publishTime ? formattedTime(item.publishTime) : '-'}
                  </div>
                  <div className={styles.boxs}>
                    <EyeO className={styles.icon} />
                    {item.viewCount ? item.viewCount : 0}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      ) : (
        // <NoData />
        <Empty description="暂无数据" />
      )}
    </div>
  );
};

export default Information;
